import React, { useState } from "react";
import { Select, Button, Typography, Spin, Card, Col, Row } from "antd";
import "./UpcomingAll.less";
import { useGetUpcomingClassesQuery } from "../../../redux/services/class";
import { useSelector } from "react-redux";
import { EmptyCard } from "../../../component";
import { useGetStudentBatchesQuery } from "../../../redux/services/batches";
import { useParams } from "react-router-dom";
import { StopOutlined } from "@ant-design/icons";

const { Title } = Typography;

const UpcomingAll = () => {
  const { student_id } = useSelector((state) => state.auth);
  const { coaching_id } = useParams();
  const [filters, setFilters] = useState({
    coaching_name: null,
    batch_name: null,
    subject: null,
  });

  const [appliedFilters, setAppliedFilters] = useState({});

  // Pass filters to the query
  const { data: upcomingClasses, isLoading: classLoading } =
    useGetUpcomingClassesQuery({
      student_id: student_id,
      coaching_id: coaching_id,
      ...appliedFilters, // Include filters in the query
    });

  const {
    data: batches,
    error,
    isLoading,
  } = useGetStudentBatchesQuery(student_id);

  const coachingOptions = React.useMemo(() => {
    if (!batches?.data) return [];
    // Transform to options array using Object.entries
    return Object.entries(batches?.data).map(([id, name]) => ({
      value: name.coaching_name,
      label: name.coaching_name,
    }));
  });

  const handleFilterChange = (value, key) => {
    setFilters({ ...filters, [key]: value });
  };

  const handleApplyFilters = () => {
    setAppliedFilters(filters);
  };

  const handleClearFilters = () => {
    setFilters({
      coaching_name: null,
      batch_name: null,
      subject: null,
    });
    setAppliedFilters({});
  };

  const UpcomingClassesCard = ({
    lectureName,
    teacherName = "Vaibhav Lehra",
    date,
    class_url,
    time,
  }) => {
    return (
      <Card className='assignment-card'>
        <Row gutter={[16, 16]} className='info-row'>
          <Col span={12}>
            <div className='info-label'>Teacher Name</div>
            <div className='info-value'>{teacherName}</div>
          </Col>
          <Col span={12}>
            <div className='info-label'>Lecture Name</div>
            <div className='info-value'>{lectureName}</div>
          </Col>
        </Row>
        <Row gutter={[16, 16]} className='info-row'>
          <Col span={12}>
            <div className='info-label'>Date</div>
            <div className='info-value'>
              {date} | {time}
            </div>
          </Col>
          <Col span={12}>
            <Button
              type='primary'
              className='view-button'
              onClick={() => window.open(class_url, "_blank")}
            >
              Join
            </Button>
          </Col>
        </Row>
      </Card>
    );
  };

  return (
    <div className='upcoming-class-container'>
      <div className='filters'>
        <Select
          placeholder='Coaching'
          value={filters.coaching_name}
          onChange={(value) => handleFilterChange(value, "coaching")}
          style={{ width: 120 }}
          options={coachingOptions}
        />
        <Select
          placeholder='Course'
          value={filters.batch_name}
          onChange={(value) => handleFilterChange(value, "course")}
          style={{ width: 120 }}
          options={[
            {
              value: "course1",
              label: "Course 1",
            },
            {
              value: "course2",
              label: "Course 2",
            },
          ]}
        />
        <Select
          placeholder='Subject'
          value={filters.subject}
          onChange={(value) => handleFilterChange(value, "subject")}
          style={{ width: 120 }}
          options={[
            {
              value: "english",
              label: "English",
            },
            {
              value: "maths",
              label: "Maths",
            },
            {
              value: "physics",
              label: "Physics",
            },
            {
              value: "chemistry",
              label: "Chemistry",
            },
          ]}
        />
        <Button type='primary' onClick={handleApplyFilters}>
          Apply
        </Button>
        <Button
          type='text'
          style={{ color: "red" }}
          icon={<StopOutlined />}
          onClick={handleClearFilters}
        />
      </div>

      <div className='upcoming-classes'>
        <Title className='title'>Upcoming Classes</Title>
        <Spin spinning={isLoading}>
          {upcomingClasses?.data?.length > 0 ? (
            upcomingClasses?.data?.map((lecture) => (
              <UpcomingClassesCard
                key={lecture.lecture_id}
                lectureName={lecture.lecture_name}
                teacherName={lecture.teacher_name}
                date={lecture.date}
                time={lecture.time}
                class_url={lecture.class_url}
              />
            ))
          ) : (
            <EmptyCard text={`No Upcoming classes`} />
          )}
        </Spin>
      </div>
    </div>
  );
};

export default UpcomingAll;
